define(
    'connections/order-connection',[
        'jquery',

        'utils/ajax-util',

        'settings',
    ],

    function ($, ajax, settings) {
        /**
         * @class OrderConnection
         */
        return (function () {

            /**
             * @constructor
             */
            function OrderConnection() { }


            /**
             * Get tracking links for order
             *
             * @method add
             * @param  {String}    - The order number that you want the links for.
             * @return {Promise}   - A jQuery ajax promise.
             */
            OrderConnection.prototype.getTrackingLinks = function (orderNr) {
                return ajax.get(settings.orderApiUrl + '/tracking/' + orderNr);
            };


            /**
             * Loads all the skus to the cart.
             * @param  {String} id - the id of the order.
             * @return {Promise}   - A jQuery ajax promise.
             */
            OrderConnection.prototype.loadAsCart = function (id) {
                return ajax.get(settings.orderApiUrl + '/loadAsCart?ordernumber=' + id);
            };

            OrderConnection.prototype.getOrderSubscriptions = function () {
                return ajax.get(settings.orderApiUrl + '/getOrderSubscriptions');
            };

            OrderConnection.prototype.addOrderSubscription = function (customerCode) {
                return ajax.post(settings.orderApiUrl + '/addOrderSubscription', { customerCode: customerCode });
            };

            OrderConnection.prototype.deleteOrderSubscription = function (id) {
                return ajax.delete(settings.orderApiUrl + '/deleteOrderSubscription', { id: id });
            };

            OrderConnection.prototype.getOrderHeaders = function (searchText, lastId, size) {
                return ajax.get(settings.orderListApiUrl, {
                    size: size,
                    fromNumber: lastId,
                    searchText: searchText,
                });
            };

            return new OrderConnection();
        })();
    }
);

